import { api } from './client'

/** Espelho das frases de `src/consoleai/changelog_novidades/resposta.py`: a tela decide
 * a apresentação comparando o texto, então as duas têm de ser idênticas às do backend. */
export const FRASE_NAO_ENCONTREI = 'Não encontrei atualização sobre isso.'
export const FRASE_NAO_RESUMI = 'Não consegui resumir; estes são os itens encontrados.'

export type EscopoDaBusca = 'minhas' | 'todas'

/** O `tipo` que a busca devolve: o valor cru da coluna `changelog_itens.tipo` (CHECK da
 * MIGRATION_421), no SINGULAR. Não confundir com as chaves de `changelog.ts`
 * (`features`/`fixes`/`improvements`), que são da lista local. Contrato conferido por
 * `tests/unit/changelog_novidades/test_routes.py::test_f1_...`. */
export type TipoDoItem = 'feature' | 'fix' | 'improvement'

export interface ItemDaBusca {
  versao: string
  /** Data ISO (AAAA-MM-DD) da versão. */
  data: string
  tipo: TipoDoItem
  texto: string
  areas: string[]
}

export interface RespostaDaBusca {
  resposta: string | null
  resposta_descartada: boolean
  itens: ItemDaBusca[]
  /** Só na aba "Minhas" e só quando nada caiu nas áreas: quantos itens há em "Todas". */
  fora_do_escopo: number
  /** `true` quando a contagem de `fora_do_escopo` bateu no teto da busca: são "N ou mais". */
  fora_do_escopo_no_teto: boolean
}

export const novidadesApi = {
  /** Cada envio custa uma chamada ao modelo: chamar no envio do campo, nunca a cada tecla. */
  buscar: async (q: string, escopo: EscopoDaBusca, areas: Iterable<string>): Promise<RespostaDaBusca> => {
    // POST com corpo, nunca `?q=`: o log de acesso grava a query string, e a pergunta não
    // pode ir para log nenhum (Ruling 26).
    const corpo = {
      q,
      escopo,
      // O recorte só vale na aba "Minhas"; em "Todas" o backend ignora e não deve recebê-lo.
      areas: escopo === 'minhas' ? [...areas].sort() : [],
    }
    const res = await api.post<RespostaDaBusca>('/v1/me/changelog/busca', corpo)
    return res.data
  },
}
